<template>
  <div class="wtb-root">

    <!-- درخت قهرمانی (فینال طلا) — رندر با vue-tournament-bracket -->
    <div class="wtb-scroll" v-if="bracket.goldTree.length" dir="ltr">
      <Bracket :flat-tree="bracket.goldTree">
        <template #player="{ player }">
          <WrestlingCell :player="player" @click="onCellClick(player)" />
        </template>
        <template #player-extension-bottom="{ match }">
          <div class="wround-chip" v-if="match.isFirstOfRound" dir="rtl">{{ match.roundFa }}</div>
        </template>
      </Bracket>
    </div>

  </div>
</template>

<script>
import Bracket from 'vue-tournament-bracket';
import WrestlingCell from './WrestlingCell.vue';
import { buildWrestlingBracket } from '@/utils/bracketBuilder';

export default {
  name: 'WrestlingBracket',
  components: { Bracket, WrestlingCell },
  props: {
    // خروجی /wrestling/matches/<id> (آرایهٔ مسابقات یک وزن)
    matches: { type: Array, default: () => [] },
  },
  computed: {
    bracket() {
      return buildWrestlingBracket(this.matches);
    },
  },
  methods: {
    onCellClick(player) {
      if (player && player.match) {
        this.$emit('match-click', player.match);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wtb-root {
  width: 100%;
}

/* اسکرول افقی نمودار (جهت LTR برای حفظ هندسهٔ خطوط اتصال کتابخانه) */
.wtb-scroll {
  overflow-x: auto;
  padding: 10px 8px 12px;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
}

/* --------- خنثی‌سازی ظاهر پیش‌فرض کتابخانه و هماهنگی با تم صفحه --------- */
::v-deep .vtb-wrapper {
  align-items: center;
  width: max-content;
  min-width: 100%;
}

::v-deep .vtb-item-players {
  background: transparent;
  color: inherit;
}

/* فاصلهٔ عمودی بازی‌ها: 10px پیش‌فرض کتابخانه → 4px (کاهش ارتفاع اسکرول نمودار) */
::v-deep .vtb-item-child {
  margin-top: 4px;
  margin-bottom: 4px;
}

::v-deep .vtb-player {
  background: transparent !important;
  padding: 2px 0;
}

::v-deep .vtb-player.winner,
::v-deep .vtb-player.defeated {
  background: transparent !important;
}

/* هایلایت یک کشتی‌گیر در سراسر درخت (قابلیت hover کتابخانه) */
::v-deep .vtb-player.highlight .wcell {
  border-color: #0d9488 !important;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.22);
}

/* خطوط اتصال همرنگ تم */
::v-deep .vtb-item-parent:after,
::v-deep .vtb-item-child:before,
::v-deep .vtb-item-child:after {
  background-color: #cbd5e1;
}

/* چیپ عنوان راند زیر اولین بازی هر راند */
.wround-chip {
  margin: 4px auto 0;
  width: max-content;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 100px;
  white-space: nowrap;
  line-height: 1.5;
}
</style>
